import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

import RoleRow from 'roles/components/RoleRow';

import { getPermissions, getCompany } from 'auth/selectors';

class RoleRowContainer extends Component {
  // handleToggle = e => {
  //   e.preventDefault();
  //   const { match: { params: { id } }, role } = this.props;
  //   this.props
  //     .toggleRole(id, role.id)
  //     .then(({ value }) => this.props.addGrowlMessage(value.message, "success", "common.success"))
  //     .catch(
  //       err => err.code !== 401 && this.props.addGrowlMessage(err.message, "danger", "common.error")
  //     );
  // };

  render = () => (
    <RoleRow
      handleToggle={this.props.handleToggle}
      id={this.props.role.id}
      role={this.props.role}
      companyId={this.props.company.id}
      isLoading={this.props.role.isSaving}
      permissions={this.props.permissions}
    />
  );
}

const mapStateToProps = (state) => ({
  permissions: getPermissions(state),
  company: getCompany(state),
});

// const mapDispatchToProps = dispatch => ({
//   toggleRole: (companyId, id) => dispatch(toggleRole(companyId, id)),
//   addGrowlMessage: (message, type, title) => dispatch(addGrowlMessage(message, type, title))
// });
export default compose(connect(mapStateToProps, null), withRouter)(RoleRowContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/roles/containers/RoleRowContainer.js